<template>
  <div>
    <v-navigation-drawer v-model="drawer" class="primary pt-16" app>
      <v-list-item-group>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="navigate(item.route)"
        >
          <v-list-item-action>
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content style="text-align: left;">
            <v-list-item-title class="white--text">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="allFlags.SOG3677"
          @click="navigate('/import-recurring-charge-file')"
        >
          <v-list-item-action>
            <v-icon class="white--text">mdi-file-import</v-icon>
          </v-list-item-action>
          <v-list-item-content style="text-align: left;">
            <v-list-item-title class="white--text">
              Import Recurring Charge Files
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="allFlags.SOG2271" @click="navigate('/logs')">
          <v-list-item-action>
            <v-icon class="white--text">mdi-history</v-icon>
          </v-list-item-action>
          <v-list-item-content style="text-align: left;">
            <v-list-item-title class="white--text">Logs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-navigation-drawer>
    <v-app-bar
      color="primary"
      style="
         {
          z-index: 3000;
        }
      "
      clipped-left
      app
      :class="{ watermarksm: isStaging }"
    >
      <v-app-bar-nav-icon
        color="white"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text pa-4">
        Bulk Upload Portal
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="authbuttons">
        <v-row no-gutters align="center">
          <v-col class="pl-4 pr-8">
            <v-btn block v-if="$auth.isAuthenticated" small @click="logout()">
              Logout
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <!-- <div class="float-left">
                <div v-if="$auth.isAuthenticated" class="float-right mr-4">
                    <span class="text-muted font-weight-light px-2 body-1">{{$auth.user.name}}</span>
                    <v-btn v-on:click="$auth.logout" class="font-weight-black">Logout</v-btn>
                </div>
            </div> -->
      <v-dialog
        v-model="mfadialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <mfa-dialog @closeDialog="closeMFADialog"></mfa-dialog>
      </v-dialog>
    </v-app-bar>
  </div>
</template>

<script>
import MfaDialog from '@/components/EnrollMFADialog.vue'

export default {
  name: 'AppSidebar',
  data: () => ({
    drawer: true,
    items: [
      { title: 'Bulk Upload CSV', icon: 'mdi-gavel', route: '/' },
      {
        title: 'Import Charge Files',
        icon: 'mdi-file-import',
        route: 'import-charge-file',
      },
      // {
      //   title: "Import Recurring Charge Files",
      //   icon: "",
      //   route: "import-recurring-charge-file",
      // },
      {
        title: 'Import Wcg Charge Files',
        icon: 'mdi-file-import',
        route: 'import-wcg-charge-file',
      },
    ],
    mfadialog: false,
  }),
  components: {
    MfaDialog,
  },
  methods: {
    navigate(route) {
      let vm = this
      vm.$router.push(route)
    },
    logout() {
      let vm = this
      vm.$auth.logout({ returnTo: window.location.origin })
    },
    openMFADialog() {
      this.mfadialog = true
    },
    closeMFADialog() {
      this.mfadialog = false
    },
    // showButton(title) {
    //     if (title === 'Home') {
    //         return true;
    //     } else {
    //         return !this.$auth.loading && this.$auth.isAuthenticated;
    //     }
    // }
  },
  computed: {
    isStaging() {
      return (
        process.env.NODE_ENV == 'staging' ||
        process.env.NODE_ENV == 'development'
      )
    },
  },
}
</script>

<style>
.v-app-bar.v-app-bar--fixed {
  z-index: 7 !important;
}
.authbuttons {
  position: absolute;
  top: 15px;
  right: 20px;
}
.watermark {
  background: url('https://vonex.com.au/vonex/projects/watermark-blck.png')
    repeat !important;
}
.watermarksm {
  background: url('https://vonex.com.au/vonex/projects/watermark-small.png')
    repeat !important;
}
</style>
